"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DpDetailedPerformanceHeaderForTeacher = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_i18next_1 = require("react-i18next");
var api_1 = require("../../../api");
var Icon_1 = __importDefault(require("../Icon/Icon"));
var DpDetailedPerformanceHeaderForTeacher_styled_1 = require("./DpDetailedPerformanceHeaderForTeacher.styled");
var DpDetailedPerformanceHeaderForTeacher = function (_a) {
    var headers = _a.headers, isDiagnostic = _a.isDiagnostic, sortingCriteriaChangeHandler = _a.sortingCriteriaChangeHandler, sortingCriteria = _a.sortingCriteria;
    var t = (0, react_i18next_1.useTranslation)('common').t;
    var iconName = function (property) {
        return (sortingCriteria === null || sortingCriteria === void 0 ? void 0 : sortingCriteria.property) === property
            ? (sortingCriteria === null || sortingCriteria === void 0 ? void 0 : sortingCriteria.direction) === api_1.SortDirectionEnumerables.ascending
                ? 'arrow-up'
                : 'arrow-down'
            : 'up-down';
    };
    var getAriaLabel = function (columnLabel, property) {
        var sortingLabels;
        var iconValue = iconName(property);
        var sortOrder = iconValue === 'arrow-up'
            ? api_1.SortDirectionEnumerables.descending
            : iconValue === 'arrow-down'
                ? api_1.SortDirectionEnumerables.ascending
                : 'default';
        if (property === 'name') {
            sortingLabels = t("DpDetailedPerformanceTableForTeacher.sortAlphabetically", {
                order: sortOrder,
                value: columnLabel,
            });
        }
        else if (property === 'overall.performance') {
            sortingLabels = t("DpDetailedPerformanceTableForTeacher.sortingOrder", {
                order: sortOrder,
                value: columnLabel,
            });
        }
        else {
            sortingLabels = t("DpDetailedPerformanceTableForTeacher.scoreSortingOrder", {
                order: sortOrder,
                value: columnLabel,
            });
        }
        return sortingLabels;
    };
    var sortingCriteriaClicked = function (columnLabel, property, id) { return function () {
        var criteria;
        var sortDirection = api_1.SortDirectionEnumerables.ascending;
        // Define the direction
        if (sortingCriteria.property !== property)
            sortDirection = api_1.SortDirectionEnumerables.ascending;
        else {
            sortDirection =
                sortingCriteria.direction === api_1.SortDirectionEnumerables.ascending
                    ? api_1.SortDirectionEnumerables.descending
                    : api_1.SortDirectionEnumerables.ascending;
        }
        // Set values for new criteria
        if (!sortingCriteria) {
            // default value
            criteria = {
                property: 'name',
                direction: api_1.SortDirectionEnumerables.ascending,
            };
        }
        else {
            criteria = {
                property: property,
                direction: sortDirection,
            };
        }
        document.getElementById(id).setAttribute('aria-label', getAriaLabel(columnLabel, property));
        sortingCriteriaChangeHandler(criteria);
    }; };
    var renderIcon = function (header, property, id) {
        var _a;
        var columnLabel = (_a = header.valueOf().props['aria-label']) === null || _a === void 0 ? void 0 : _a.split(',')[0];
        return ((0, jsx_runtime_1.jsx)("span", { className: "padding-button question-".concat(id), children: (0, jsx_runtime_1.jsx)("button", { id: id, className: "sorting-column", "aria-label": getAriaLabel(columnLabel, property), onClick: sortingCriteriaClicked(columnLabel, property, id), children: (0, jsx_runtime_1.jsx)(Icon_1.default, { name: iconName(property) }) }) }));
    };
    var renderSortableColumn = function (columnLabel, property, id) { return ((0, jsx_runtime_1.jsxs)("button", { onClick: sortingCriteriaClicked(columnLabel, property, id), className: "btn-clearfix", "aria-label": getAriaLabel(columnLabel, property), children: [columnLabel, (0, jsx_runtime_1.jsx)("span", { className: "padding-button", children: (0, jsx_runtime_1.jsx)("span", { className: "sorting-column", id: id, children: (0, jsx_runtime_1.jsx)(Icon_1.default, { name: iconName(property) }) }) })] })); };
    return ((0, jsx_runtime_1.jsx)(DpDetailedPerformanceHeaderForTeacher_styled_1.StyledDetailedPerformanceHeaderForTeacher, { isDiagnostic: isDiagnostic, "data-testid": "dp-detailed-performance-header", children: (0, jsx_runtime_1.jsxs)("tr", { className: "student-details-header", children: [(0, jsx_runtime_1.jsx)("th", { className: "student", scope: "col", children: renderSortableColumn(t("DpDetailedPerformanceTableForTeacher.studentName"), 'name', 'student') }), (0, jsx_runtime_1.jsx)("th", { className: "overall", scope: "col", children: renderSortableColumn(t("DpDetailedPerformanceTableForTeacher.overall"), 'overall.performance', 'overall') }), headers.map(function (header, index) { return ((0, jsx_runtime_1.jsx)("th", { className: "data-header question-label-".concat(index), scope: "col", children: (0, jsx_runtime_1.jsxs)("div", { className: "column-header", children: [header, renderIcon(header, "performances[".concat(index, "].performance"), "".concat(index))] }) }, index)); })] }) }));
};
exports.DpDetailedPerformanceHeaderForTeacher = DpDetailedPerformanceHeaderForTeacher;
exports.default = exports.DpDetailedPerformanceHeaderForTeacher;
